import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
export const CreateScreenGroupRequestSchema = z.object({
    name: z.string().min(1).max(200),
});
export const UpdateScreenGroupRequestSchema = z.object({
    name: z.string().min(1).max(200),
});
export const ScreenGroupSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    name: z.string().min(1),
    memberCount: z.number().int().nonnegative(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const ScreenGroupDetailSchema = ScreenGroupSchema.extend({
    screenIds: z.array(z.string().min(1)),
});
export const AddScreenGroupMemberRequestSchema = z.object({
    screenId: z.string().min(1),
});
//# sourceMappingURL=screen-group.js.map